// This icon file is generated automatically.
var PSecurityScanOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.55 1.65L7.24-.15A.77.77 0 007-.2a.77.77 0 00-.24.04l-5.3 1.8a.37.37 0 00-.24.34v7.53c0 .14.09.32.2.4l5.38 4.2c.06.05.13.07.2.07s.14-.02.2-.06l5.38-4.2c.1-.09.2-.27.2-.4V1.98c0-.14-.1-.29-.23-.34zm-.9 7.57L7 12.85 2.34 9.22V2.54L7 .95l4.66 1.6v6.67zM5.3 7.26L4.08 8.47a.13.13 0 000 .18l.54.53c.04.05.12.05.17 0L6 7.97a2.25 2.25 0 10-.7-.7zm1.02-2.08a1.25 1.25 0 111.77 1.77 1.25 1.25 0 01-1.77-1.77z", "fill-rule": "nonzero" } }] }, "name": "p-security-scan", "theme": "outlined" };
export default PSecurityScanOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSecurityScanOutlined.js
// module id = 3625
// module chunks = 0